import React, { useState } from 'react'
import { createUseStyles } from 'react-jss';
import { FormikProps } from 'formik';
import { ICustomization, IMaterialOtherPreference } from './MaterialOtherPreferences.template';
import {  PREFERRED_DELIVERY_DATE, TRADE_TYPE, cityOptions } from '../../../../utils/constant';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { IMaterialRequirementOtherPreference } from '../../../../services/useMaterialRequirementOtherPreferenceService';
import { MODE } from '../../../../utils/types';
import ErrorMessage from '../../../atoms/ErrorMessage/ErrorMessage';
import MultiSelectInput2, { IMultiSelectOption } from '../../../atoms/MultiSelectInput2';
import ButtonV2 from '../../../atoms/ButtonV2';
import SelectV2 from '../../../atoms/SelectV2';

interface MaterialOtherPreferencesFormTemplateProps {
    handleCustomization: (name: string) => (e: any) => void;
    handleSelectChange: (key: string) => (event: any) => void;
    handleMultiSelectChange: (key: string) => (option: IMultiSelectOption[]) => void;
    customizations: ICustomization[];
    formik: FormikProps<IMaterialOtherPreference>
}

const useStyles = createUseStyles((theme: any) => ({
    primary500: {
        color: theme.palette.textV2.primary.primary500,
    },
    borderColor: {
        border: `1px solid ${theme.palette.backgroundV2.secondary.secondary50}`
    },
    heading: {
        color: theme.palette.textV2.tertiary.tertiary700
    },
    tertiary100Border: {
        borderColor: theme.palette.textV2.tertiary.tertiary100
    },
    sectionBackground: {
        background: theme.palette.backgroundV2.tertiary.tertiary500
    },
    checkedInputColor: {
        color: theme.palette.textV2.tertiary.tertiary300,
        '&.Mui-checked': {
            color: theme.palette.textV2.primary.primary400,
        },
    }
}));
const MaterialOtherPreferencesFormTemplate: React.FC<MaterialOtherPreferencesFormTemplateProps> = ({ customizations, formik, handleCustomization, handleSelectChange, handleMultiSelectChange }) => {
    const classes = useStyles();
    return (
        <form className={` p-6 grid gap-6 rounded-lg ${classes.sectionBackground}`} onSubmit={formik.handleSubmit}>
            <div className={`grid gap-6`}>
                <div className={`w-full flex justify-between items-center`}>
                    <span className={`${classes.heading} text-2xl`}>Other Preference</span>
                    <ButtonV2 variant='tertiaryContained' type="submit" label="Save" className='!font-normal' />
                </div>
                <div className={`${classes.tertiary100Border} border-b`}></div>
                <div className={`grid grid-cols-2 gap-6`}>
                    <SelectV2
                        {...formik.getFieldProps('preferredDeliveryTime')}
                        options={PREFERRED_DELIVERY_DATE.map((option: any) => ({ label: option.label, value: option.value }))}
                        label="Delivery time after order"
                        value={formik.values.preferredDeliveryTime}
                        onChange={handleSelectChange('preferredDeliveryTime')}
                        fullWidth
                        placeholder='Select Delivery Date'
                        error={formik.touched.preferredDeliveryTime && Boolean(formik.errors.preferredDeliveryTime)}
                        helperText={formik.errors?.preferredDeliveryTime}
                    />
                    <MultiSelectInput2
                        {...formik.getFieldProps('preferredDeliveryLocation')}
                        options={cityOptions.map(option => ({ label: option.label, value: option.id }))}
                        label="Preferred Delivery Location"
                        value={formik.values.preferredDeliveryLocation}
                        onchange={handleMultiSelectChange('preferredDeliveryLocation')}
                        fullWidth
                        placeholder='Select Delivery Location'
                        error={formik.touched.preferredDeliveryLocation && Boolean(formik.errors.preferredDeliveryLocation)}
                        helperText={formik.errors?.preferredDeliveryLocation as string}
                    />
                </div>
            </div>
            <div className={`grid gap-6`}>
                <div className={`w-full flex justify-between items-center`}>
                    <span className={`${classes.heading} text-2xl`}>Customization</span>
                </div>

                <div className={`${classes.tertiary100Border} border-b`}></div>

                <div >
                    <div className={`grid gap-x-6 grid-cols-4`}>
                        {
                            customizations.map((customization) => (
                                <FormControlLabel
                                    control={<Checkbox 
                                    className={`${classes.checkedInputColor}`}/>}
                                    label={customization.name}
                                    checked={formik.values.customization?.includes(customization.name)}
                                    className={`rounded-lg border p-4 !ml-0 ${classes.tertiary100Border}`}
                                    {...formik.getFieldProps('customization')}
                                    onChange={handleCustomization(customization.name)} 
                                    />
                            ))
                        }
                        {formik.touched.customization && Boolean(formik.errors.customization) && <ErrorMessage message={formik?.errors?.customization as string}/>}
                    </div>
                </div>

            </div>
            <div className={`grid gap-6`}>
                <div className={`w-full flex justify-between items-center`}>
                    <span className={`${classes.heading} text-2xl`}>Import/Export</span>
                </div>
                <div className={`${classes.tertiary100Border} border-b`}></div>
                <div className={`grid gap-6 grid-cols-2`}>
                    <SelectV2
                        {...formik.getFieldProps('tradeType')}
                        options={TRADE_TYPE.map(option => ({ label: option.label, value: option.value }))}
                        label="Trade Type"
                        value={formik.values.tradeType}
                        onChange={handleSelectChange('tradeType')}
                        placeholder='Select Trade Type'
                        error={formik.touched.tradeType && Boolean(formik.errors.tradeType)}
                        helperText={formik.errors?.tradeType}
                    />
                </div>
            </div>
        </form>
    )
}

export default MaterialOtherPreferencesFormTemplate